import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import PromoPopupManager from "@/components/PromoPopupManager";
import AdminLayout from "@/components/admin/AdminLayout";
import AdminProtectedRoute from "@/components/admin/AdminProtectedRoute";
import Home from "@/pages/Home";
import HowItWorks from "@/pages/HowItWorks";
import Plans from "@/pages/Plans";
import Reviews from "@/pages/Reviews";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import Signin from "@/pages/Signin";
import Signup from "@/pages/Signup";
import SignupSuccess from "@/pages/SignupSuccess";
import MockCheckout from "@/pages/MockCheckout";
import Unsubscribe from "@/pages/Unsubscribe";
import Portal from "@/pages/Portal";
import AuthPlaceholder from "@/pages/AuthPlaceholder";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminCustomers from "@/pages/admin/AdminCustomers";
import AdminJobs from "@/pages/admin/AdminJobs";
import AdminQuoteInbox from "@/pages/admin/AdminQuoteInbox";
import AdminTestimonials from "@/pages/admin/AdminTestimonials";
import AdminValueProps from "@/pages/admin/AdminValueProps";
import AdminPromoPopup from "@/pages/admin/AdminPromoPopup";
import AdminCoupons from "@/pages/admin/AdminCoupons";
import AdminEmailLog from "@/pages/admin/AdminEmailLog";
import { Navigate } from "react-router-dom";

function App() {
  return (
    <div className="App font-sans text-ink antialiased">
      <BrowserRouter>
        <AdminAuthProvider>
          <AuthProvider>
            <PromoPopupManager />
            <Routes>
              {/* Public site */}
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/how-it-works" element={<HowItWorks />} />
                <Route path="/plans" element={<Plans />} />
                <Route path="/reviews" element={<Reviews />} />
                <Route path="/faq" element={<Faq />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/signin" element={<Signin />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/signup/success" element={<SignupSuccess />} />
                <Route path="/mock-checkout" element={<MockCheckout />} />
                <Route path="/unsubscribe" element={<Unsubscribe />} />
                <Route
                  path="/portal"
                  element={
                    <ProtectedRoute>
                      <Portal />
                    </ProtectedRoute>
                  }
                />
              </Route>

              {/* Admin (no public Layout chrome) */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <AdminProtectedRoute>
                    <AdminLayout />
                  </AdminProtectedRoute>
                }
              >
                <Route index element={<Navigate to="/admin/overview" replace />} />
                <Route path="overview" element={<AdminOverview />} />
                <Route path="customers" element={<AdminCustomers />} />
                <Route path="jobs" element={<AdminJobs />} />
                <Route path="quote-inbox" element={<AdminQuoteInbox />} />
                <Route path="testimonials" element={<AdminTestimonials />} />
                <Route path="value-props" element={<AdminValueProps />} />
                <Route path="promo-popup" element={<AdminPromoPopup />} />
                <Route path="coupons" element={<AdminCoupons />} />
                <Route path="email-log" element={<AdminEmailLog />} />
              </Route>

              <Route path="*" element={<AuthPlaceholder mode="notfound" />} />
            </Routes>
          </AuthProvider>
        </AdminAuthProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors closeButton />
    </div>
  );
}

export default App;
